import { render } from "./my-pagination.vue?vue&type=template&id=17c01f2e&scoped=true"
import script from "./my-pagination.vue?vue&type=script&lang=js"
export * from "./my-pagination.vue?vue&type=script&lang=js"

import "./my-pagination.vue?vue&type=style&index=0&id=17c01f2e&lang=less&scoped=true"

import exportComponent from "C:\\Users\\tkken\\Documents\\Rouling\\open-platform-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c01f2e"]])

export default __exports__